export default "__VITE_ASSET__0a385d13__"